import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import classNames from 'classnames';
import moment from 'moment';
import Alert from "react-s-alert";
import { PatientRecordRecordFrequencyList, SavePatientRecordFrequencyData } from '../../actions/BehaviourDataActions';
import Loader from '../../../../../../../../img/loader.gif';
import RecordFrequencyDataViewModal from './RecordFrequencyDataViewModal';
import FrequencyGraphModal from '../../FrequencyGraphModal/index';
import { delay } from 'lodash';
class RecordFrequency extends Component {

    constructor(props) {
        super(props);
        this.state = {
            patientId: props.patientId ? props.patientId : null,
            creadteDate: moment().utc().format('YYYY-MM-DDTHH:mm:ss'),
            FrequencyArray: [],
            Id: [],
            todayRecordFrequencyDataViewModal: false,
            FrequencyGraphModalOpen:false,
            modalTitle:'',
            behaviorsReductionId:-1,
            recordingTypeName:'Frequency'
        }
        this.onGraphHandler = this.onGraphHandler.bind(this);
    }

    renderLoading() {
        if (this.state.isLoading) {
            return (
                <div className="full_loader">
                    <div className="circle_loader page_loader">
                        <img src={Loader} alt="" />
                    </div>
                </div>
            );
        }
    }

    componentWillMount = () => {
        this.props.PatientRecordRecordFrequencyList(this.state.patientId)
    }

    componentWillReceiveProps = (nextProps) => {
        if( nextProps.recordFrequencyList.data !== undefined) {
            let freqData = this.state.FrequencyArray
            let Id = this.state.Id
            let patientBehaviorsReductionData = nextProps.recordFrequencyList.data.PatientBehaviorsReductionData;
            patientBehaviorsReductionData.map((obj, index) => {
                return freqData[index] = 0;
            })
            patientBehaviorsReductionData.map((obj, index) => {
                return Id[index] = obj.id;
            })
            this.setState({
                FrequencyArray: freqData,
                Id: Id
            })
        }
    }

    alertRaiser = (type, index)=>{
        Alert.warning('Data has already been added to the Daily Summary. If you proceed, the existing Daily Summary data will be overwritten.', {
            position: 'bottom-right',
            effect: 'slide',
            timeout: 10000,
            customFields: {
              displayComponent: true,
              handleButtonClick: ()=>this. freuencyClickHandler(type, index),
              // id: obj.id,
            },
          });
    }

    freuencyClickHandler = (type, index) => {
        Alert.closeAll()
        const feqValue = this.state.FrequencyArray;  
        if(feqValue[index] > 0) {
            feqValue[index] = feqValue[index];
        } else {
            feqValue[index] = 0;
        }
        if(type === "Minus" && feqValue[index] > 0) {
            feqValue[index] = feqValue[index] - 1;
        } else if(type === "Plus"){
            feqValue[index] = feqValue[index] + 1;       
        }
        this.setState({
            FrequencyArray: feqValue
        })
    }

    handleSaveFrequency = () => {
        let finalData = [];
        this.state.Id.map((obj,index) => {
            let patientRecordFrequencyDataDetailsModelData = {
                "recordFrequencyDataDetailId": 0,
                "recordFrequencyDataId": 0,
                "behaviorsReductionId": obj,
                "value":  this.state.FrequencyArray[index]
            } 
            finalData.push(patientRecordFrequencyDataDetailsModelData)
        })

        let authData = {
            "id": 0,
            "patientId": this.state.patientId,
            "sessionId": this.props.uuid,
            "sessionDate":  this.state.creadteDate,
            "patientRecordFrequencyDataDetailsModel": finalData
        }
        this.props.SavePatientRecordFrequencyData(authData)

        delay(()=>  this.props.PatientRecordRecordFrequencyList(this.state.patientId),200)
      
    }

    handleClose = () => {
        this.setState({
            todayRecordFrequencyDataViewModal: false,
            FrequencyGraphModalOpen:false,
            modalTitle:'',
            behaviorsReductionId:-1
        })
    }

    onGraphHandler(e,obj){
        e.preventDefault();
        this.setState({
            FrequencyGraphModalOpen: true,
            modalTitle: obj.behaviorName,
            behaviorsReductionId: obj.id
        })
    }


    todayRecordFrequencyDataView = () => {
        this.setState({
            todayRecordFrequencyDataViewModal : true
        })
        
    }

    renderData = (dataList) => {
        let PatientRecordFrequencyData = dataList || [];
        if (!PatientRecordFrequencyData.length) {
            return (
                <tr>
                    <td colSpan='4'>
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return PatientRecordFrequencyData.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td width="30%">
                        {Obj.behaviorName}
                    </td>
                    <td width="20%">
                        {Obj.description}
                    </td>
                    <td width="30%">
                        <div className='row'>
                            {/* <div className="col-sm-1"> </div> */}
                            <div className="col-sm-3">
                                <button
                                    name={`freuencyMinus${index}`}
                                    className="tableadd"
                                    title="Minus"
                                    type="button"
                                    onClick={() => this.freuencyClickHandler("Minus",index)}
                                    >
                                    <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                                </button>
                            </div>
                            <div className="col-sm-3">{this.state.FrequencyArray[index] || 0}</div>
                            <div className="col-sm-3">
                                <button
                                    name={`freuencyPlus${index}`}
                                    className="tableadd"
                                    title="Plus"
                                    type="button"
                                    onClick={() => this.props.recordFrequencyList.data.PatientBehaviorsReductionData[index].isDataCollectedInDailySummaryData&&this.state.FrequencyArray[index]===0?this.alertRaiser("Plus", index):this.freuencyClickHandler("Plus", index)}                                    >
                                    <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                                </button>
                            </div>
                            {/* <div className="col-sm-2"> </div> */}
                        </div>


                    </td>
                    <td width="20%">
                        {/* {(this.state.targetType && this.state.targetType[index])?( */}
                            <button type="button" onClick={(e) => this.onGraphHandler(e,Obj)} title="Graph" className="tbactionbtn bluefont"><i className="fa fa-line-chart" aria-hidden="true"></i></button>
                        {/* ):''} */}
                    </td>  
                </tr>
            )
        })
    }

    renderRecordFrequency = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        const { recordFrequencyList } = this.props;
        let PatientRecordFrequencyList = (recordFrequencyList && recordFrequencyList.data) || [];
        return (
            <div className="table-responsive mt-15">
                <table className={tableClass}>
                    <thead>
                        <tr>
                            <th width="30%">Frequency</th>
                            <th width="20%">Operational Definition</th>
                            <th width="30%"></th>
                            <th width="20%">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderData(PatientRecordFrequencyList.PatientBehaviorsReductionData)}
                    </tbody>
                </table>
            </div>
        )
    }


    render() {

        return (
            <div>
                {this.renderLoading()}
               
                <div className="clearfix"></div>
                    <div className="readmin-panel">
                        <div className="panel-body">
                            <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 btn_rt reset-btn claims_filter">
                            {this.props.addPermissionBehavior && <RaisedButton
                                    style={{ marginTop: '10px', marginRight: '22px', float: 'right' }}
                                    label="SAVE"
                                    primary={true}
                                    onTouchTap={() => this.handleSaveFrequency()} />}

                                <RaisedButton
                                    style={{ marginTop: '10px', marginRight: '22px', float: 'right' }}
                                    className="ml_15"
                                    onClick={() => this.todayRecordFrequencyDataView()}
                                    label="Today's Frequency Data"
                                    primary={true}>
                                </RaisedButton>
                            </div>
                               
                                {this.renderRecordFrequency()}
                                {
                                            this.state.FrequencyGraphModalOpen &&
                                            <FrequencyGraphModal
                                                patientId={this.state.patientId}
                                                closeDialog={() => this.handleClose()}
                                                recordingTypeName={this.state.recordingTypeName}
                                                behaviorsReductionId={this.state.behaviorsReductionId}
                                                modalTitle={this.state.modalTitle}
                                            />
                                        }
                            </div>
                            {
                                this.state.todayRecordFrequencyDataViewModal && <RecordFrequencyDataViewModal 
                                 patientId={this.state.patientId}
                                 creadtedDate={moment().format('YYYY-MM-DDTHH:mm:ss')}
                                 uuid={this.props.uuid}
                                 closeDialog={() => this.handleClose()} 
                                 updatePermissionBehavior = {this.props.updatePermissionBehavior}
                                deletePermissionBehavior =  {this.props.deletePermissionBehavior}
                                />
                            }
                        </div>
                    </div>
            </div>
        )
    }
}

RecordFrequency = reduxForm({
    form: 'RecordFrequency',
    enableReinitialize: true,
})(RecordFrequency);

function mapStateToProps(state) {
    return {
        loading: state.patientBehaviourData.loading,
        recordFrequencyList: state.patientBehaviourData.frequencyDataList !== null ? state.patientBehaviourData.frequencyDataList : [],
        uuid: state.patientSkillAcqActiveProgram.uuid,
    }
}

export default connect(mapStateToProps, { PatientRecordRecordFrequencyList, SavePatientRecordFrequencyData })(RecordFrequency);



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/RecordFrequency/RecordFrequency.js